/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Change_Detection_Alert_TitleInputs */



/**
* | output |
* | --- |
* | "Shot Change Detection" |
*
* @param {Scene_Change_Detection_Alert_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_change_detection_alert_title = /** @type {((inputs?: Scene_Change_Detection_Alert_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Change_Detection_Alert_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Detection de changement de plan")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schusswechselerkennung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rilevamento del cambio di tiro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обнаружение смены кадра")
	if (locale === "es") return /** @type {LocalizedString} */ ("Detección de cambios de disparo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("投篮变化检测")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ショットチェンジ検出")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शॉट परिवर्तन का पता लगाना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Detecção de mudança de tiro")
	return /** @type {LocalizedString} */ ("Shot Change Detection")
});